import { render, staticRenderFns } from "./Imagenes.vue?vue&type=template&id=3713ffbc&scoped=true&"
import script from "./Imagenes.vue?vue&type=script&lang=js&"
export * from "./Imagenes.vue?vue&type=script&lang=js&"
import style0 from "./Imagenes.vue?vue&type=style&index=0&id=3713ffbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3713ffbc",
  null
  
)

export default component.exports